import React from 'react'
import EBook from '../components/e-book/EBook'

function EBookPage() {
  return (
    <div>
      <EBook />
    </div>
  )
}

export default EBookPage
